"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBDropdownMenu", {
  enumerable: true,
  get: function get() {
    return _SVBDropdownMenu.default;
  }
});
var _SVBDropdownMenu = _interopRequireDefault(require("./src/SVBDropdownMenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }